import React from 'react'
import PropTypes from 'prop-types'
import styles from '../TabStyles'
import PostApptReviewMessage from './index'
import buildTextEditor from '../../buildTextEditor'

const PostApptReviewEmailEditor = buildTextEditor(PostApptReviewMessage)
const EmailEditors = ({ editors }) => (
  <div style={styles.editorColumn}>
    {editors.map(({
      pmsType,
      pmsVersion,
      setting,
      title,
      updateSetting,
    }) => (
      <PostApptReviewEmailEditor
        hasPlum={false}
        hasReviews
        isEmail
        key={setting.id}
        pmsType={pmsType}
        pmsVersion={pmsVersion}
        setting={setting}
        title={title}
        updateSetting={updateSetting}
      />
    ))}
  </div>
)

EmailEditors.propTypes = {
  editors: PropTypes.arrayOf(
    PropTypes.shape({
      pmsType: PropTypes.string,
      pmsVersion: PropTypes.number,
      setting: PropTypes.shape({
        id: PropTypes.number,
      }),
      title: PropTypes.string,
      updateSetting: PropTypes.func.isRequired,
    }),
  ),
}

export default EmailEditors



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/PostApptReviewSettingsEditors/EmailEditors.js